import React from 'react';
import { Facebook, Twitter, Instagram, Mail, MessageCircle, Phone } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-black border-t border-gold-500/30 pt-16 pb-8" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-65">
          {/* Brand */}
          <div data-id="element-66">
            <a href="#" className="flex flex-col mb-6" data-id="element-67">
              <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-68">
                IsYou <span className="text-gold-500" data-id="element-69">.</span>
              </span>
              <span className="text-[10px] text-gray-400 tracking-[0.2em] uppercase" data-id="element-70">
                新加坡是您网
              </span>
            </a>
            <p className="text-gray-500 text-sm leading-relaxed mb-6" data-id="element-71">
              新加坡首选的高端伴游服务平台，致力于为精英人士提供尊贵、私密、安全的伴游体验。
            </p>
            <div className="flex space-x-4" data-id="element-72">
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-73">
                <Facebook className="w-5 h-5" data-id="element-74" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-75">
                <Twitter className="w-5 h-5" data-id="element-76" />
              </a>
              <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors" data-id="element-77">
                <Instagram className="w-5 h-5" data-id="element-78" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-79">
            <h4 className="text-white font-bold mb-6" data-id="element-80">快速链接</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-81">
              <li data-id="element-82">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-83">
                  首页
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-85">
                  伴游女郎
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-87">
                  服务流程
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-89">
                  关于我们
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-91">
                  加入我们
                </a>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div data-id="element-92">
            <h4 className="text-white font-bold mb-6" data-id="element-93">帮助中心</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-94">
              <li data-id="element-95">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-96">
                  常见问题
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-98">
                  隐私政策
                </a>
              </li>
              <li data-id="element-99">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-100">
                  服务条款
                </a>
              </li>
              <li data-id="element-101">
                <a href="#" className="hover:text-gold-500 transition-colors" data-id="element-102">
                  安全指南
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-103">
            <h4 className="text-white font-bold mb-6" data-id="element-104">联系我们</h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-105">
              <li className="flex items-center" data-id="element-106">
                <MessageCircle className="w-4 h-4 text-gold-500 mr-3" data-id="element-107" />
                <span data-id="element-108">WhatsApp: +65 8888 8888</span>
              </li>
              <li className="flex items-center" data-id="element-109">
                <Phone className="w-4 h-4 text-gold-500 mr-3" data-id="element-110" />
                <span data-id="element-111">Telegram: @IsYouSG</span>
              </li>
              <li className="flex items-center" data-id="element-112">
                <Mail className="w-4 h-4 text-gold-500 mr-3" data-id="element-113" />
                <span data-id="element-114">contact@isyou.sg</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-115">
          <p data-id="element-116">&copy; 2026 IsYou. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-117">
            <a href="#" className="hover:text-gray-400" data-id="element-118">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-119">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}